import { IUploadedFileDto } from "../common/model/file-exchange-dto";

export const FileToExchangeDto = async (file: File) => {
    const fileReader = new FileReader();

    return await new Promise<IUploadedFileDto>(resolve => {
        fileReader.onload = async () => {
            const content = fileReader.result as string;

            resolve({
                filename: file.name,
                mimeType: file.type,
                content: content.slice(content.indexOf(";base64,") + 8),
            });
        };

        fileReader.readAsDataURL(file);
    });
};
